<template>
    <div class="warehouses app__page">
        <div class="app__page-header">
            <h1 class="app__page-header-title">{{ $tc("pages.warehouses") }}</h1>
            <sah-button @click.native="newWarehouse">+</sah-button>
        </div>
        <div class="warehouses__list app__cards-list">
            <warehouse-show
                v-for="warehouse in warehouses"
                :warehouse="warehouse"
                :key="warehouse.name"
                @edit="editWarehouse"
                @import="importApplications"
                @export="exportApplications"
            >
            </warehouse-show>
        </div>
        <warehouse-edit
            v-if="isEditing"
            :warehouse="editedWarehouse"
            :operation="editOperation"
            @cancel="closeEdit"
            @end="closeEdit"
        ></warehouse-edit>
        <warehouse-export
            v-if="isExporting"
            :warehouse="exportingWarehouse"
            @cancel="closeExport"
            @end="closeExport"
        ></warehouse-export>
        <warehouse-import
            v-if="isImporting"
            :warehouse="importingWarehouse"
            @cancel="closeImport"
            @end="closeImport"
        ></warehouse-import>
    </div>
</template>

<script>
import {store} from "atom";
import {SahButton} from "atom";
import WarehouseShow from "@/components/WarehouseShow.vue";
import WarehouseEdit from "@/components/WarehouseEdit.vue";
import WarehouseImport from "@/components/WarehouseImport.vue";
import WarehouseExport from "@/components/WarehouseExport.vue";
import {EDIT_OPERATION_STORE, EDIT_OPERATION_UPDATE} from "../constants";

const {createNamespacedHelpers} = store;
const {mapState, mapGetters} = createNamespacedHelpers("arcman");

/**
 * Renderer for the landing page of the application
 */
export default {
    name: "warehouses",
    components: {
        SahButton,
        WarehouseEdit,
        WarehouseExport,
        WarehouseImport,
        WarehouseShow,
    },
    computed: {
        ...mapGetters({showSpinner: "showWarehousesSpinner"}),
        ...mapState(["warehouses", "arcologyConstants"]),
        warehouseTemplate() {
            return JSON.parse(JSON.stringify(this.arcologyConstants.WAREHOUSE_TEMPLATE));
        },
    },
    watch: {
        showSpinner(newValue, oldValue) {
            this.$emit("showSpinner", newValue);
        },
    },
    data() {
        return {
            isEditing: false,
            isExporting: false,
            isImporting: false,
            editOperation: "",
            editedWarehouse: {},
            importingWarehouse: {},
        };
    },
    methods: {
        editWarehouse(event) {
            this.isEditing = true;
            this.editOperation = EDIT_OPERATION_UPDATE;
            this.editedWarehouse = event;
        },
        newWarehouse() {
            this.isEditing = true;
            this.editOperation = EDIT_OPERATION_STORE;
            this.editedWarehouse = this.warehouseTemplate;
        },
        closeEdit() {
            this.isEditing = false;
        },
        exportApplications(event) {
            this.isExporting = true;
            this.exportingWarehouse = event;
        },
        importApplications(event) {
            this.isImporting = true;
            this.importingWarehouse = event;
        },
        closeExport() {
            this.isExporting = false;
        },
        closeImport() {
            this.isImporting = false;
        },
    },
};
</script>
